import React from 'react'
import "./ExpencesChart.css"
import { Chart } from "react-google-charts";
import sett from "../../assets/img/sett.png"

export const data = [
    ["id", "name", "Age", "Donuts eaten"],
    ["Service charges", "Male", 12, 45000],
    ["Spares", "Female", 22, 30000],
    ["AMC", "NonBinary", 22, 10000],
    ["CMC", "Female", 20, 15000],

];

export const options = {
    legend: "none",
    chartArea: { left: 0, top: 0, right: 0, bottom: 0 },
    pieSliceText: "label",
    pieHole: 0.5
};

const ExpencesChat = () => {
    return (
        <div>
            {/* card_1 */}
            <div className='card_exp'>
                <h4 className='exp_h'>Expenses</h4>
                <div className='chart_23'>
                    <Chart
                        chartType="PieChart"
                        width="90%"
                        height="200px"
                        data={data}
                        options={options}
                        chartWrapperParams={{ view: { columns: [0, 3] } }}
                    />
                </div>
            </div>

            {/* card_2 */}
            <div className='card_exp2'>
                <h4 className='exp_h2'>In service</h4>
                <div className='none'>
                    <img className='img_Set' src={sett} alt='' />
                </div>
                <div className='total_s'>
                    Total services
                    <span style={{ color: "#004F95", fontWeight: 800, textAlign: "center" }}> 38</span>
                </div>
                <div className='total_sn'>
                    Open services
                    <span style={{ color: "#004F95", fontWeight: 800, textAlign: "center" }}> 18</span>
                </div>
            </div>

            {/* card-3 */}


            {/* card-4 */}
            
        </div>
    )
}

export default ExpencesChat
